/**
 * Become a Member Service Page
 */
import React from 'react';
import ServicePageLayout from '../../landing/components/service-pages/ServicePageLayout';
import becomeMemberConfig from '../data/becomeMemberConfig';

const BecomeMemberPage = () => {
  return <ServicePageLayout config={becomeMemberConfig} />;
};

export default BecomeMemberPage;
